// RFC4646
type CultureCodeOption = { value: string; label: string }
export const CultureCodes: CultureCodeOption[] = [
  {
    value: 'af',
    label: 'Afrikaans',
  },
  {
    value: 'sq',
    label: 'Albanian',
  },
  {
    value: 'ar-sa',
    label: 'Arabic (Saudi Arabia)',
  },
  {
    value: 'ar-iq',
    label: 'Arabic (Iraq)',
  },
  {
    value: 'ar-eg',
    label: 'Arabic (Egypt)',
  },
  {
    value: 'ar-ly',
    label: 'Arabic (Libya)',
  },
  {
    value: 'ar-dz',
    label: 'Arabic (Algeria)',
  },
  {
    value: 'ar-ma',
    label: 'Arabic (Morocco)',
  },
  {
    value: 'ar-tn',
    label: 'Arabic (Tunisia)',
  },
  {
    value: 'ar-om',
    label: 'Arabic (Oman)',
  },
  {
    value: 'ar-ye',
    label: 'Arabic (Yemen)',
  },
  {
    value: 'ar-sy',
    label: 'Arabic (Syria)',
  },
  {
    value: 'ar-jo',
    label: 'Arabic (Jordan)',
  },
  {
    value: 'ar-lb',
    label: 'Arabic (Lebanon)',
  },
  {
    value: 'ar-kw',
    label: 'Arabic (Kuwait)',
  },
  {
    value: 'ar-ae',
    label: 'Arabic (U.A.E.)',
  },
  {
    value: 'ar-bh',
    label: 'Arabic (Bahrain)',
  },
  {
    value: 'ar-qa',
    label: 'Arabic (Qatar)',
  },
  {
    value: 'eu',
    label: 'Basque (Basque)',
  },
  {
    value: 'bg',
    label: 'Bulgarian',
  },
  {
    value: 'be',
    label: 'Belarusian',
  },
  {
    value: 'ca',
    label: 'Catalan',
  },
  {
    value: 'zh-tw',
    label: 'Chinese (Taiwan)',
  },
  {
    value: 'zh-cn',
    label: 'Chinese (PRC)',
  },
  {
    value: 'zh-hk',
    label: 'Chinese (Hong Kong SAR)',
  },
  {
    value: 'zh-sg',
    label: 'Chinese (Singapore)',
  },
  {
    value: 'hr',
    label: 'Croatian',
  },
  {
    value: 'cs',
    label: 'Czech',
  },
  {
    value: 'da',
    label: 'Danish',
  },
  {
    value: 'nl',
    label: 'Dutch (Standard)',
  },
  {
    value: 'nl-be',
    label: 'Dutch (Belgium)',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'en-us',
    label: 'English (United States)',
  },
  {
    value: 'en-gb',
    label: 'English (United Kingdom)',
  },
  {
    value: 'en-au',
    label: 'English (Australia)',
  },
  {
    value: 'en-ca',
    label: 'English (Canada)',
  },
  {
    value: 'en-nz',
    label: 'English (New Zealand)',
  },
  {
    value: 'en-ie',
    label: 'English (Ireland)',
  },
  {
    value: 'en-za',
    label: 'English (South Africa)',
  },
  {
    value: 'en-jm',
    label: 'English (Jamaica)',
  },
  {
    value: 'en',
    label: 'English (Caribbean)',
  },
  {
    value: 'en-bz',
    label: 'English (Belize)',
  },
  {
    value: 'en-tt',
    label: 'English (Trinidad)',
  },
  {
    value: 'et',
    label: 'Estonian',
  },
  {
    value: 'fo',
    label: 'Faeroese',
  },
  {
    value: 'fa',
    label: 'Farsi',
  },
  {
    value: 'fi',
    label: 'Finnish',
  },
  {
    value: 'fr',
    label: 'French (Standard)',
  },
  {
    value: 'fr-be',
    label: 'French (Belgium)',
  },
  {
    value: 'fr-ca',
    label: 'French (Canada)',
  },
  {
    value: 'fr-ch',
    label: 'French (Switzerland)',
  },
  {
    value: 'fr-lu',
    label: 'French (Luxembourg)',
  },
  {
    value: 'gd',
    label: 'Gaelic (Scotland)',
  },
  {
    value: 'ga',
    label: 'Irish',
  },
  {
    value: 'de',
    label: 'German (Standard)',
  },
  {
    value: 'de-ch',
    label: 'German (Switzerland)',
  },
  {
    value: 'de-at',
    label: 'German (Austria)',
  },
  {
    value: 'de-lu',
    label: 'German (Luxembourg)',
  },
  {
    value: 'de-li',
    label: 'German (Liechtenstein)',
  },
  {
    value: 'el',
    label: 'Greek',
  },
  {
    value: 'he',
    label: 'Hebrew',
  },
  {
    value: 'hi',
    label: 'Hindi',
  },
  {
    value: 'hu',
    label: 'Hungarian',
  },
  {
    value: 'is',
    label: 'Icelandic',
  },
  {
    value: 'id',
    label: 'Indonesian',
  },
  {
    value: 'it',
    label: 'Italian (Standard)',
  },
  {
    value: 'it-ch',
    label: 'Italian (Switzerland)',
  },
  {
    value: 'ja',
    label: 'Japanese',
  },
  {
    value: 'ko',
    label: 'Korean',
  },
  {
    value: 'ko',
    label: 'Korean (Johab)',
  },
  {
    value: 'lv',
    label: 'Latvian',
  },
  {
    value: 'lt',
    label: 'Lithuanian',
  },
  {
    value: 'mk',
    label: 'Macedonian (FYROM)',
  },
  {
    value: 'ms',
    label: 'Malaysian',
  },
  {
    value: 'mt',
    label: 'Maltese',
  },
  {
    value: 'no',
    label: 'Norwegian (Bokmal)',
  },
  {
    value: 'no',
    label: 'Norwegian (Nynorsk)',
  },
  {
    value: 'pl',
    label: 'Polish',
  },
  {
    value: 'pt-br',
    label: 'Portuguese (Brazil)',
  },
  {
    value: 'pt',
    label: 'Portuguese (Portugal)',
  },
  {
    value: 'rm',
    label: 'Rhaeto-Romanic ',
  },
  {
    value: 'ro',
    label: 'Romanian',
  },
  {
    value: 'ro-mo',
    label: 'Romanian (Republic of Moldova)',
  },
  {
    value: 'ru',
    label: 'Russian',
  },
  {
    value: 'ru-mo',
    label: 'Russian (Republic of Moldova)',
  },
  {
    value: 'sz',
    label: 'Sami (Lappish)',
  },
  {
    value: 'sr',
    label: 'Serbian (Cyrillic)',
  },
  {
    value: 'sr',
    label: 'Serbian (Latin)',
  },
  {
    value: 'sk',
    label: 'Slovak',
  },
  {
    value: 'sl',
    label: 'Slovenian',
  },
  {
    value: 'sb',
    label: 'Sorbian',
  },
  {
    value: 'es',
    label: 'Spanish (Spain)',
  },
  {
    value: 'es-mx',
    label: 'Spanish (Mexico)',
  },
  {
    value: 'es-gt',
    label: 'Spanish (Guatemala)',
  },
  {
    value: 'es-cr',
    label: 'Spanish (Costa Rica)',
  },
  {
    value: 'es-pa',
    label: 'Spanish (Panama)',
  },
  {
    value: 'es-do',
    label: 'Spanish (Dominican Republic)',
  },
  {
    value: 'es-ve',
    label: 'Spanish (Venezuela)',
  },
  {
    value: 'es-co',
    label: 'Spanish (Colombia)',
  },
  {
    value: 'es-pe',
    label: 'Spanish (Peru)',
  },
  {
    value: 'es-ar',
    label: 'Spanish (Argentina)',
  },
  {
    value: 'es-ec',
    label: 'Spanish (Ecuador)',
  },
  {
    value: 'es-cl',
    label: 'Spanish (Chile)',
  },
  {
    value: 'es-uy',
    label: 'Spanish (Uruguay)',
  },
  {
    value: 'es-py',
    label: 'Spanish (Paraguay)',
  },
  {
    value: 'es-bo',
    label: 'Spanish (Bolivia)',
  },
  {
    value: 'es-sv',
    label: 'Spanish (El Salvador)',
  },
  {
    value: 'es-hn',
    label: 'Spanish (Honduras)',
  },
  {
    value: 'es-ni',
    label: 'Spanish (Nicaragua)',
  },
  {
    value: 'es-pr',
    label: 'Spanish (Puerto Rico)',
  },
  {
    value: 'sx',
    label: 'Sutu',
  },
  {
    value: 'sv',
    label: 'Swedish',
  },
  {
    value: 'sv-fi',
    label: 'Swedish (Finland)',
  },
  {
    value: 'th',
    label: 'Thai',
  },
  {
    value: 'ts',
    label: 'Tsonga',
  },
  {
    value: 'tn',
    label: 'Tswana',
  },
  {
    value: 'tr',
    label: 'Turkish',
  },
  {
    value: 'uk',
    label: 'Ukrainian',
  },
  {
    value: 'ur',
    label: 'Urdu',
  },
  {
    value: 've',
    label: 'Venda',
  },
  {
    value: 'vi',
    label: 'Vietnamese',
  },
  {
    value: 'xh',
    label: 'Xhosa',
  },
  {
    value: 'ji',
    label: 'Yiddish',
  },
  {
    value: 'zu',
    label: 'Zulu',
  },
]

export const defaultCulture: string = 'en-us'

export function getLanguageFromCulture(culture?: string) {
  if (!culture) return 'en'
  return culture.split('-')[0] || 'en'
}

const sampleTextPerLanguage: { [lang: string]: string } = {
  en: 'This is how I sound when I speak.',
  sp: 'Así es como sueno cuando hablo.',
  pt: 'É assim que eu soando quando falo.',
  ru: 'Вот как я звучу, когда говорю.',
  jp: 'これが私が話すときの声です。',
  zh: '这是我说话时的声音。',
  de: 'So klinge ich, wenn ich spreche.',
  fr: 'Voici comment je sonne quand je parle.',
}

export function getSampleText(culture: string) {
  return sampleTextPerLanguage[getLanguageFromCulture(culture)] || sampleTextPerLanguage['en']
}
